import { GET_FORM_ACTIONS_ERROR } from './';

export default error => dispatch =>
  dispatch({ type: GET_FORM_ACTIONS_ERROR, payload: { error } });
